<template>
    <section ref="section">
        <form @submit.prevent>
        </form>
        <header>Protokolliste</header>
        <div class="search-bar" v-if="userRole === 'administrator'">
            <search-bar :initial-value="searchQuery" @search="handleSearch"></search-bar>
        </div>
        <div class="container protocol-list-scroll">
            <table
                ref="table"
                class="table protocol-table"
                :class="{
                    'has-admin-actions': userRole === 'administrator',
                    'is-mobile-list': isMobileList,
                }"
            >
                <thead>
                    <tr>
                        <th scope="col" class="col-index">#</th>
                        <th scope="col" class="col-date">
                            Datum
                            <font-awesome-icon class="btn-icons" @click="sortList('date')" :icon="sortIcon('date')" />
                        </th>
                        <th scope="col" class="col-objekt">
                            <span class="th-full">Objektadresse</span>
                            <span class="th-short">Adresse</span>
                            <font-awesome-icon class="btn-icons" @click="sortList('objekt')" :icon="sortIcon('objekt')" />
                        </th>
                        <th scope="col" class="col-type">
                            <span class="th-full">Protokolltyp</span>
                            <span class="th-short">Typ</span>
                            <font-awesome-icon class="btn-icons" @click="sortList('type')" :icon="sortIcon('type')" />
                        </th>
                        <!-- <th scope="col">Images</th> -->
                        <th scope="col" class="col-user" v-if="userRole === 'administrator'">
                            Benutzer
                        </th>
                        <th scope="col" class="col-status">
                            Status
                            <font-awesome-icon class="btn-icons" @click="sortList('status')" :icon="sortIcon('status')" />
                        </th>
                        <th scope="col" class="col-options">
                            <span class="th-full">Optionen</span>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="listLoading && records.length === 0">
                    <tr>
                        <td :colspan="userRole === 'administrator' ? 7 : 6" class="list-loading-cell">
                            Protokolle werden geladen…
                        </td>
                    </tr>
                </tbody>
                <tbody v-else v-for="(item, index) in sortedItems" :key="index">
                    <tr
                        v-if="index >= startRow && index < endRow"
                        class="protocol-row"
                        :class="{ 'protocol-row-open': isMobileList }"
                        @click="onProtocolRowClick(item)"
                    >
                        <td class="col-index" data-label="#">{{ index + 1 }}</td>
                        <td class="col-date" data-label="Datum">{{ formatDateOnly(item.date) }}</td>
                        <td data-label="Objektadresse" class="cell-objekt col-objekt">
                            <span class="cell-objekt-text">{{ item.objekt }}</span>
                            <span class="cell-meta">
                                <span>{{ shortType(item.type) }}</span>
                                <span v-if="userRole === 'administrator'">{{ item.userName }}</span>
                                <span>{{ formatStatus(item.status) }}</span>
                            </span>
                        </td>
                        <td class="col-type" data-label="Protokolltyp">
                            <span class="type-full">{{ item.type }}</span>
                            <span class="type-short">{{ shortType(item.type) }}</span>
                        </td>
                        <!-- <td>{{ item.images.length }}</td> -->
                        <td
                            v-if="userRole === 'administrator'"
                            class="col-user"
                            data-label="Benutzer"
                        >{{ item.userName }}</td>
                        <td class="record-status col-status" data-label="Status">
                            <div class="record-status-inner">
                                <p>{{ formatStatus(item.status) }}</p>
                                <button v-if="userRole === 'administrator'" class="btn btn-success status-btn"
                                    @click.stop="changeRecordStatus(index, item._id, item.status)"
                                    title="Status ändern"
                                    aria-label="Status ändern">
                                    <font-awesome-icon class="status-icon" style="color:white" icon="fa-exchange" />
                                </button>
                            </div>
                        </td>
                        <td class="options-cell col-options" data-label="Optionen">
                            <div class="options-cell-inner">
                                <button v-if="userRole === 'administrator'" class="btn btn-success status-btn status-btn-compact"
                                    @click.stop="changeRecordStatus(index, item._id, item.status)"
                                    title="Status ändern"
                                    aria-label="Status ändern">
                                    <font-awesome-icon class="status-icon" style="color:white" icon="fa-exchange" />
                                </button>
                                <router-link
                                    v-if="!isMobileList"
                                    :to="previewProtokol(item._id, item.status)"
                                >
                                    <button type="button" class="btn btn-info btn-open" style="color:white"
                                        title="Öffnen"
                                        aria-label="Öffnen">
                                        <span class="btn-open-label">Öffnen</span>
                                        <font-awesome-icon class="option-icon" style="color:white" icon="fa-file-text" />
                                    </button>
                                </router-link>
                                <button v-if="
                                    isInBearbeitung(item.status) ||
                                    userRole === 'administrator'
                                " type="button" class="btn btn-danger btn-delete-row" @click.stop="doDelete(item._id, index)"
                                    title="Löschen"
                                    aria-label="Löschen">
                                    <font-awesome-icon icon="fa-trash-can" />
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="paginator" ref="paginator">
            <ul class="pagination-list pagination">
                <li>
                    <button class="page-link page-link-nav" @click="moveToPage('prev')" :disabled="disabledPreviousButton === true">
                        Prev.
                    </button>
                </li>
                <li v-for="item in listOfPages" :key="item">
                    <button
                        type="button"
                        class="page-link page-link-number"
                        :class="{ active: currentPage === item }"
                        :aria-current="currentPage === item ? 'page' : undefined"
                        @click="moveToPage(item)"
                    >
                        {{ item }}
                    </button>
                </li>
                <li>
                    <button class="page-link page-link-nav" @click="moveToPage('next')" :disabled="disabledNextButton === true">
                        Next
                    </button>
                </li>
            </ul>

            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </div>
    
    </section>
</template>

<script>
import axios from 'axios';
import ConfirmDialogue from '../static_elements/ConfirmDialogue.vue';
import { useToast } from 'vue-toastification';
import SearchBar from '../SearchBar.vue';

import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { isMobileBuild, isNativeApp } from '@/utils/platform';

const MOBILE_LIST_MQ = '(max-width: 1024px)';

const DEFAULT_ROWS_PER_PAGE = 9;
const MIN_ROWS_PER_PAGE = 5;
const MAX_ROWS_PER_PAGE = 50;
const DEFAULT_PAGE_SLOTS = 5;

function isForcedMobileList() {
    return isMobileBuild() || isNativeApp();
}

// Höhenänderungen darunter (Adressleiste ein-/ausfahren, Pull-to-Refresh) ändern die
// Seitengröße nicht, sonst springt die Liste samt Seitenleiste beim Scrollen.
const VIEWPORT_HEIGHT_TOLERANCE_PX = 120;
const RESIZE_SETTLE_MS = 200;

// Position im Dokument über offsetTop: unabhängig von Scrollposition und
// iOS-Gummiband (scrollY < 0 beim Runterziehen).
function documentBottom(el) {
    let top = 0;
    for (let node = el; node; node = node.offsetParent) {
        top += node.offsetTop;
    }
    return top + el.offsetHeight;
}

function isTouchDevice() {
    return Boolean(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
}

function isPinchZoomed() {
    return Boolean(window.visualViewport && window.visualViewport.scale > 1.01);
}

// Kurzzeit-Cache: beim Zurück von der Detailansicht sofort Daten zeigen
const LIST_CACHE_TTL_MS = 60_000;
const listCache = new Map();

function listCacheKey(userName, listType) {
    return `${userName}|${listType}`;
}

function readListCache(userName, listType) {
    const entry = listCache.get(listCacheKey(userName, listType));
    if (!entry) {
        return null;
    }
    if (Date.now() - entry.ts > LIST_CACHE_TTL_MS) {
        listCache.delete(listCacheKey(userName, listType));
        return null;
    }
    return entry.records;
}

function writeListCache(userName, listType, records) {
    listCache.set(listCacheKey(userName, listType), {
        records: Array.isArray(records) ? records.slice() : [],
        ts: Date.now(),
    });
}

function queryString(value) {
    return typeof value === 'string' ? value : '';
}

function parsePage(value) {
    const page = Number.parseInt(queryString(value), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
}

function isCanceled(err) {
    return err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError';
}

// Die API liefert Protokolle in Speicherreihenfolge (ältestes zuerst).
// Liste und Suche zeigen dasselbe: neuestes Datum oben.
function newestFirst(records) {
    return Array.isArray(records) ? records.slice().reverse() : [];
}

function invalidateListCache(userName, listType) {
    if (userName && listType) {
        listCache.delete(listCacheKey(userName, listType));
    } else {
        listCache.clear();
    }
}

export default {
    components: { ConfirmDialogue, SearchBar },

    data() {
        const userRole = this.$store.state.auth.user.role;
        return {
            protokolId: '',
            userName: '',
            listType: this.$route.params.listType,
            userRole,
            records: [],
            listLoading: true,
            protokolStatus: '',
            // Paggination (an die Fensterhöhe angepasst, siehe fitRowsToViewport)
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            rowsFitted: false,
            pageSlots: DEFAULT_PAGE_SLOTS,
            currentPage: parsePage(this.$route.query.page),
            // Sorting by value
            sortOrder: 'asc',
            sortKey: 'address',
            // Modal Windows
            showModalMessage: false,
            deleteConfirmation: '',
            removeConfirmed: 0,
            // Toast
            toast: useToast(),
            
            // Search bar
            searchQuery: userRole === 'administrator' ? queryString(this.$route.query.q) : '',
            filteredRecords: '',
            isNarrowViewport: false,
        };
    },
    props: ['itemId'],
    created() {
        this.listAbort = null;
        this.searchAbort = null;
        this.pageAnchor = null;
        this.userName = this.$store.state.auth.user.login;
        if (this.searchQuery.trim()) {
            this.runSearch(this.searchQuery);
        } else {
            this.loadList();
        }
        this.syncNarrowViewport();
        if (typeof window !== 'undefined' && window.matchMedia && !isForcedMobileList()) {
            this.mobileListMq = window.matchMedia(MOBILE_LIST_MQ);
            this.onMobileListMqChange = (event) => {
                this.isNarrowViewport = event.matches;
            };
            if (this.mobileListMq.addEventListener) {
                this.mobileListMq.addEventListener('change', this.onMobileListMqChange);
            } else {
                this.mobileListMq.addListener(this.onMobileListMqChange);
            }
        }
    },
    mounted() {
        this.onWindowResize = () => {
            window.clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => {
                this.resizeTimer = null;
                if (isPinchZoomed()) {
                    return;
                }
                if (window.scrollY < 0) {
                    this.onWindowResize();
                    return;
                }
                const fitted = this.fittedViewport;
                if (
                    fitted &&
                    isTouchDevice() &&
                    fitted.width === window.innerWidth &&
                    Math.abs(fitted.height - window.innerHeight) < VIEWPORT_HEIGHT_TOLERANCE_PX
                ) {
                    return;
                }
                this.fitRowsToViewport();
            }, RESIZE_SETTLE_MS);
        };
        window.addEventListener('resize', this.onWindowResize);
        this.scheduleFit();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.scheduleFit());
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
        if (this.listAbort) {
            this.listAbort.abort();
            this.listAbort = null;
        }
        if (this.searchAbort) {
            this.searchAbort.abort();
            this.searchAbort = null;
        }
        if (this.mobileListMq && this.onMobileListMqChange) {
            if (this.mobileListMq.removeEventListener) {
                this.mobileListMq.removeEventListener('change', this.onMobileListMqChange);
            } else {
                this.mobileListMq.removeListener(this.onMobileListMqChange);
            }
            this.mobileListMq = null;
        }
    },
    watch: {
        // Vor der ersten Messung zählt noch die Standardgröße; die Seite aus der URL
        // darf dann nicht schon gekappt werden.
        pageCount(count) {
            if (this.rowsFitted && this.currentPage > count) {
                this.currentPage = count;
            }
        },
        currentPage() {
            this.syncRouteQuery();
        },
        isMobileList() {
            this.scheduleFit();
        },
    },
    methods: {
        applyRecords(records) {
            this.records = Array.isArray(records) ? records.slice() : [];
            this.pageAnchor = null;
            this.scheduleFit();
        },
        scheduleFit() {
            this.$nextTick(() => this.fitRowsToViewport());
        },
        // pageAnchor hält den ersten Eintrag fest, bis der Nutzer selbst blättert.
        // Sonst wandert die Position beim Ziehen des Fensters über Zwischengrößen.
        setRowsPerPage(count) {
            if (count === this.rowsPerPage) {
                return;
            }
            if (this.pageAnchor == null) {
                this.pageAnchor = this.startRow;
            }
            this.rowsPerPage = count;
            this.currentPage = Math.floor(this.pageAnchor / count) + 1;
        },
        // Seitenleiste bleibt einzeilig: nur so viele Seitenzahlen, wie neben Prev./Next passen.
        fitPageSlotsToWidth() {
            const list = this.$refs.paginator?.querySelector('.pagination-list');
            const numberButton = list?.querySelector('.page-link-number');
            if (!list || !numberButton) {
                return;
            }
            const outerWidth = (el) => {
                const style = getComputedStyle(el);
                return (
                    el.getBoundingClientRect().width +
                    (parseFloat(style.marginLeft) || 0) +
                    (parseFloat(style.marginRight) || 0)
                );
            };
            const listStyle = getComputedStyle(list);
            const available =
                list.clientWidth -
                (parseFloat(listStyle.paddingLeft) || 0) -
                (parseFloat(listStyle.paddingRight) || 0);
            let navWidth = 0;
            list.querySelectorAll('.page-link-nav').forEach((button) => {
                navWidth += outerWidth(button);
            });
            const slotWidth = outerWidth(numberButton);
            if (!slotWidth) {
                return;
            }
            this.pageSlots = Math.max(1, Math.floor((available - navWidth) / slotWidth));
        },
        fitRowsToViewport(pass = 0) {
            const { section, table, paginator } = this.$refs;
            if (!section || !table || !paginator) {
                return;
            }
            this.fitPageSlotsToWidth();
            const rows = table.querySelectorAll('tr.protocol-row');
            if (!rows.length) {
                // Seite aus der URL liegt mit der Standardgröße hinter dem Listenende.
                if (this.records.length && this.currentPage > this.pageCount) {
                    this.currentPage = this.pageCount;
                    this.scheduleFit();
                }
                return;
            }
            let rowsHeight = 0;
            let rowHeight = 0;
            rows.forEach((row) => {
                const height = row.getBoundingClientRect().height;
                rowsHeight += height;
                rowHeight = Math.max(rowHeight, height);
            });
            const sectionPaddingBottom = parseFloat(getComputedStyle(section).paddingBottom) || 0;
            const contentBottom = documentBottom(paginator) + sectionPaddingBottom;
            const overhead = contentBottom - rowsHeight;
            const viewportHeight = window.innerHeight;
            this.fittedViewport = { width: window.innerWidth, height: viewportHeight };
            const fitting = Math.min(
                MAX_ROWS_PER_PAGE,
                Math.max(MIN_ROWS_PER_PAGE, Math.floor((viewportHeight - overhead) / rowHeight)),
            );
            const changed = fitting !== this.rowsPerPage;
            if (this.rowsFitted) {
                this.setRowsPerPage(fitting);
            } else {
                // Erste Messung: die Seite aus der URL wurde in der Regel mit derselben
                // Fenstergröße gewählt und wird deshalb nicht umgerechnet.
                this.rowsPerPage = fitting;
            }
            // Mit der neuen Seitenzahl kann die Seitenleiste ein- statt zweizeilig werden
            // (oder umgekehrt), deshalb noch einmal nachmessen.
            if (changed && pass < 2) {
                this.$nextTick(() => this.fitRowsToViewport(pass + 1));
                return;
            }
            if (!this.rowsFitted) {
                this.rowsFitted = true;
                if (this.currentPage > this.pageCount) {
                    this.currentPage = this.pageCount;
                }
            }
        },
        // Suche und Seite stehen in der URL, damit Browser-Zurück und
        // „Zurück zur Protokolliste“ dieselbe Ansicht wiederherstellen.
        syncRouteQuery() {
            const current = this.$route.query;
            const query = { ...current };
            if (this.searchQuery) {
                query.q = this.searchQuery;
            } else {
                delete query.q;
            }
            if (this.currentPage > 1) {
                query.page = String(this.currentPage);
            } else {
                delete query.page;
            }
            if (query.q === current.q && query.page === current.page) {
                return;
            }
            this.$router
                .replace({ name: this.$route.name, params: this.$route.params, query })
                .catch(() => {});
        },
        loadList() {
            const cached = readListCache(this.userName, this.listType);
            if (cached) {
                this.applyRecords(cached);
                this.listLoading = false;
            }
            this.fetchList({ background: Boolean(cached) });
        },
        async fetchList({ background = false } = {}) {
            if (this.listAbort) {
                this.listAbort.abort();
            }
            const controller = new AbortController();
            this.listAbort = controller;
            if (!background) {
                this.listLoading = true;
            }
            try {
                const response = await axios.get(
                    `${API_BACKEND_URL}list/${this.userName}/${this.listType}`,
                    { signal: controller.signal },
                );
                const records = newestFirst(response.data);
                writeListCache(this.userName, this.listType, records);
                if (!this.searchQuery.trim()) {
                    this.applyRecords(records);
                }
            } catch (err) {
                if (!isCanceled(err)) {
                    console.error('Protokolliste konnte nicht geladen werden:', err);
                }
            } finally {
                if (this.listAbort === controller) {
                    this.listAbort = null;
                    this.listLoading = false;
                }
            }
        },
        async runSearch(query) {
            if (this.searchAbort) {
                this.searchAbort.abort();
            }
            if (this.listAbort) {
                this.listAbort.abort();
                this.listAbort = null;
            }
            const controller = new AbortController();
            this.searchAbort = controller;
            this.listLoading = true;
            try {
                const res = await axios.get(`${API_BACKEND_URL}search`, {
                    params: { q: query },
                    signal: controller.signal,
                });
                this.applyRecords(newestFirst(res.data));
            } catch (err) {
                if (!isCanceled(err)) {
                    console.error('Suche fehlgeschlagen:', err);
                }
            } finally {
                if (this.searchAbort === controller) {
                    this.searchAbort = null;
                    this.listLoading = false;
                }
            }
        },
        handleSearch(inputValue) {
            this.searchQuery = inputValue;
            this.currentPage = 1;
            this.pageAnchor = null;
            this.syncRouteQuery();
            if (inputValue.trim()) {
                this.runSearch(inputValue);
                return;
            }
            if (this.searchAbort) {
                this.searchAbort.abort();
                this.searchAbort = null;
            }
            this.loadList();
        },
        syncNarrowViewport() {
            this.isNarrowViewport =
                typeof window !== 'undefined' &&
                window.matchMedia &&
                window.matchMedia(MOBILE_LIST_MQ).matches;
        },
        previewProtokol(id, status) {
            return {
                name: 'displayProtokol',
                params: {
                    itemId: id,
                    status: status,
                },
                query: {
                    from: this.listType,
                    ...(this.searchQuery ? { listQ: this.searchQuery } : {}),
                    ...(this.currentPage > 1 ? { listPage: String(this.currentPage) } : {}),
                },
            };
        },
        onProtocolRowClick(item) {
            if (!this.isMobileList || !item?._id) {
                return;
            }
            this.$router.push(this.previewProtokol(item._id, item.status));
        },
        isInBearbeitung(status) {
            return status === 'In Bearbeitung' || status === 'In bearbeitung';
        },
        formatStatus(status) {
            if (this.isInBearbeitung(status)) {
                return 'In Bearbeitung';
            }
            return status;
        },
        shortType(type) {
            if (type === 'Wöchentliche Reinigung') {
                return 'Reinigung';
            }
            return type;
        },
        formatDateOnly(value) {
            if (!value) return '';
            const str = String(value).trim();
            if (/^\d{2}\.\d{2}\.\d{4}/.test(str)) {
                return str.split(' ')[0];
            }
            const datePart = str.includes('T') ? str.split('T')[0] : str.split(' ')[0];
            const [y, m, d] = datePart.split('-');
            if (y && m && d && y.length === 4) {
                return `${d}.${m}.${y}`;
            }
            return datePart;
        },
        moveToPage(item) {
            let nextPage = this.currentPage;

            if (item === 'prev') {
                nextPage = this.currentPage - 1;
            } else if (item === 'next') {
                nextPage = this.currentPage + 1;
            } else {
                nextPage = item;
            }

            if (nextPage < 1 || nextPage > this.pageCount) {
                return;
            }

            this.currentPage = nextPage;
            this.pageAnchor = null;
        },
        sortList(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortOrder = 'asc';
            }
        },
        sortIcon(key) {
            if (this.sortKey !== key) {
                return 'fas fa-arrows-alt-v';
            } else if (this.sortOrder === 'asc') {
                return 'fas fa-sort-up';
            } else {
                return 'fas fa-sort-down';
            }
        },
        sortItems() {
            const isDesc = this.sortOrder === 'desc';
            return this.records.sort((a, b) => {
                if (
                    typeof a[this.sortKey] === 'string' &&
                    typeof b[this.sortKey] === 'string'
                ) {
                    return isDesc
                        ? b[this.sortKey].localeCompare(a[this.sortKey])
                        : a[this.sortKey].localeCompare(b[this.sortKey]);
                } else {
                    return isDesc
                        ? b[this.sortKey] - a[this.sortKey]
                        : a[this.sortKey] - b[this.sortKey];
                }
            });
        },
        async changeRecordStatus(index, id, chStatus) {
            if (chStatus === 'Abgeschlossen') {
                chStatus = 'In Bearbeitung'
            } else if (this.isInBearbeitung(chStatus)) {
                chStatus = 'Abgeschlossen'
            }
            const okStatusUpdate = await this.$refs.confirmDialogue.show({
                title: 'Protokollstatus ändern',
                message:
                    'Bist du sicher?',
                okButton: 'Ändern',
            });
            if (okStatusUpdate) {
                try {
                    await axios.put(`${API_BACKEND_URL}update_record_status/${id}/${chStatus}`)
                        .then((res) => {
                            if (res.status === 200) {
                                this.sortedItems[index].status = chStatus;
                                invalidateListCache();
                                this.toast.success(
                                    'Fertig!',
                                    {
                                        timeout: 2000,
                                    },
                                );
                            } else {
                                console.log(res.data)
                                this.toast.warning(
                                    'Unbekannter Fehler!',
                                    {
                                        timeout: 2000,
                                    },
                                )
                            }
                        })
                } catch (err) {
                    console.log(err)
                    this.toast.warning(
                        'Unbekannter Fehler!',
                        {
                            timeout: 2000,
                        },
                    );
                }
            }
        }
        ,

        async deleteRecord(id, index) {
            if (confirm('Are you sure')) this.showModalMessage = true;
            this.deleteConfirmation =
                '<button type="button" class="btn btn-light" @click="removeConfirmed = 2">Confirm<button><button type="button" class="btn btn-light" @click="removeConfirmed = ">No<button>';

            if (index > -1 && this.removeConfirmed === 2) {
                this.showModalMessage = false;
            } else if (this.removeConfirmed == 1) {
                this.showModalMessage = false;
            }
        },

        async doDelete(id, index) {
            const okDelete = await this.$refs.confirmDialogue.show({
                title: 'Protokoll löschen',
                message:
                    'Protokoll endgültig löschen?',
                okButton: 'Löschen',
            });
            if (okDelete) {
                try {
                    await axios
                        .delete(
                            `${API_BACKEND_URL}delete_record/${id}`,
                            {
                                method: 'DELETE',
                            },
                        )
                        .then((response) => {
                            this.sortedItems.splice(index, 1);
                            listCache.clear();
                            if (!this.searchQuery.trim()) {
                                writeListCache(this.userName, this.listType, this.records);
                            }
                            if (response.status === 204) {
                                // toast.success('Wow so easy!');
                                this.toast.success(
                                    'Fertig!',
                                    {
                                        timeout: 2000,
                                    },
                                );
                            }
                        });
                } catch (error) {
                    this.toast.error('Unbekannter fehler!', {
                        timeout: 2000,
                    });
                    console.error(error);
                }
            }
        },
    },
    computed: {
        sortedItems() {
            return this.sortItems();
        },
        isMobileList() {
            return isForcedMobileList() || this.isNarrowViewport;
        },
        pageCount() {
            return Math.max(1, Math.ceil(this.records.length / this.rowsPerPage));
        },
        listOfPages() {
            if (this.records.length === 0) {
                return [];
            }
            const slots = Math.min(this.pageSlots, this.pageCount);
            let first = Math.max(1, this.currentPage - Math.floor(slots / 2));
            first = Math.min(first, this.pageCount - slots + 1);
            return Array.from({ length: slots }, (_, i) => first + i);
        },
        startRow() {
            return (this.currentPage - 1) * this.rowsPerPage;
        },
        endRow() {
            return this.startRow + this.rowsPerPage;
        },
        disabledPreviousButton() {
            return this.currentPage <= 1;
        },
        disabledNextButton() {
            return this.currentPage >= this.pageCount;
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

section {
    margin-top: var(--app-header-height);
    padding: 0.35rem 1rem calc(var(--app-footer-height) + 0.5rem);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

header {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
    display: flex;
    justify-content: center;
    align-items: center;
}

.search-bar {
    margin-bottom: 0.5rem;

    /* appearance: none;
        border: 0;
        border-bottom: 2px solid lightblue; */
}

.container {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
}

.list-loading-cell {
    text-align: center;
    padding: 1.5rem 0.75rem;
    color: #555;
    font-style: italic;
}

table button {
    padding: 0.3rem 0.55rem;
    font-size: 0.85rem;
    white-space: nowrap;
}

.record-status,
.options-cell {
    white-space: nowrap;
}

.search-bar-input {}

.btn-icons {
    cursor: pointer;
    margin-left: 0.2rem;
}

th,
td {
    text-align: center;
    vertical-align: middle;
}

.col-objekt,
.cell-objekt,
.col-type {
    text-align: left;
    padding-left: 0.75rem;
}

.th-short,
.type-short,
.cell-meta {
    display: none;
}

.record-status-inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.record-status p {
    display: inline-block;
    margin: 0;
    white-space: nowrap;
}

.status-btn {
    flex-shrink: 0;
}

.status-icon {
    margin-left: 0.15rem;
}

.options-cell-inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.options-cell-inner .btn {
    flex-shrink: 0;
    white-space: nowrap;
}

.options-cell .option-icon {
    margin-left: 0.35rem;
}

.status-btn-compact {
    display: none;
}

.protocol-table.is-mobile-list .protocol-row-open {
    cursor: pointer;
}

.protocol-table.is-mobile-list .protocol-row-open:active {
    background-color: rgba(38, 66, 113, 0.08);
}

.protocol-table.is-mobile-list .options-cell-inner {
    gap: 0.85rem;
}

ul {
    display: flex;
    justify-content: center;
}

ul li {
    list-style: none;
}

.pagination-list li button.page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1px 3px;
    color: white;
    background-color: #264271;
    text-decoration: none;
    border: 1px solid #dddddd;
    cursor: pointer;
}

.pagination-list li button.page-link-number {
    width: 2.5rem;
    height: 2.5rem;
    padding: 0.35rem;
    font-size: 1rem;
    border-radius: 50%;
}

.pagination-list li button.page-link-nav {
    width: auto;
    min-width: 4.25rem;
    height: 2.5rem;
    padding: 0.35rem 0.85rem;
    font-size: 0.85rem;
    border-radius: 1.25rem;
    white-space: nowrap;
}



.pagination-list li button.page-link:hover {
    border: 3px solid #264271;
    /* border-color: ; */
    color: #264271;
    background-color: #fdfdfd;
    background-image: -webkit-linear-gradient(top, #fefefe, #fafafa);
}

.pagination-list li button.page-link.active {
    color: #264271;
    font-weight: 700;
    background-color: #ffffff;
    background-image: none;
    border: 3px solid #264271;
    box-shadow: 0 0 0 2px rgba(38, 66, 113, 0.2);
    cursor: default;
}

.pagination-list li button.page-link.active:hover {
    color: #264271;
    background-color: #ffffff;
    background-image: none;
    border: 3px solid #264271;
}

.pagination-list li button.page-link:disabled {
    background-color: #696969;
}

.btn-delete {
    font-size: 1.4rem;
    border: none;
}

.delete-btn {
    padding: 0.5em 1em;
    background-color: #eccfc9;
    color: #c5391a;
    border: 2px solid #ea3f1b;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
}

.paginator {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 0;
}

.pagination{
    max-width: 90vw;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: nowrap;
}

@media (max-width: 1024px) {
    section {
        padding: 0.15rem 0.4rem calc(var(--app-footer-height) + 0.35rem);
        align-items: stretch;
        overflow-x: hidden;
        max-width: 100%;
    }

    header {
        font-size: 1.2rem;
        margin-bottom: 0.3rem;
    }

    .search-bar {
        width: 100%;
        margin-bottom: 0.35rem;
    }

    .container,
    .protocol-list-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior-x: contain;
        touch-action: pan-x pan-y;
        padding: 0;
        margin: 0;
        max-width: 100%;
    }

    .th-full {
        display: none;
    }

    .th-short {
        display: inline;
    }

    .col-index,
    .col-type,
    .col-status,
    .col-user {
        display: none;
    }

    .cell-meta {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 0.15rem 0.55rem;
        margin-top: 0.12rem;
        font-size: 0.68rem;
        font-weight: 500;
        color: #5a6a86;
        line-height: 1.25;
    }

    .protocol-table {
        table-layout: fixed;
        width: max(100%, 16rem);
        max-width: none;
        margin: 0;
        font-size: 0.72rem;
        border: 0;
        --bs-table-bg: transparent;
    }

    .protocol-table.has-admin-actions {
        width: max(100%, 18.75rem);
    }

    .protocol-table thead th {
        padding: 0.3rem 0.15rem;
        font-size: 0.68rem;
        font-weight: 700;
        color: #264271;
        line-height: 1.2;
        border-bottom-width: 1px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .protocol-table .btn-icons {
        display: none;
    }

    .protocol-table tbody td {
        padding: 0.32rem 0.18rem;
        line-height: 1.25;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        vertical-align: middle;
    }

    .col-date {
        width: 4.85rem;
        min-width: 4.85rem;
        white-space: nowrap;
    }

    .col-objekt {
        min-width: 8.5rem;
    }

    .protocol-table td.col-date {
        white-space: nowrap;
        overflow-wrap: normal;
        word-break: normal;
        font-variant-numeric: tabular-nums;
        font-size: 0.72rem;
    }

    .col-options {
        width: 2.4rem;
        min-width: 2.4rem;
        overflow: visible;
    }

    .protocol-table.has-admin-actions .col-options {
        width: 5rem;
        min-width: 5rem;
    }

    .protocol-table.is-mobile-list .options-cell-inner {
        justify-content: flex-end;
        gap: 0.85rem;
    }

    .protocol-table td.cell-objekt {
        text-align: left;
        font-weight: 600;
    }

    .cell-objekt-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .record-status,
    .options-cell {
        white-space: normal;
    }

    .options-cell-inner {
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        gap: 0.2rem;
        width: 100%;
        white-space: nowrap;
    }

    .options-cell-inner a {
        display: inline-flex;
        flex: 0 0 auto;
        line-height: 0;
    }

    .btn-open-label {
        display: none;
    }

    .options-cell .option-icon {
        margin-left: 0;
    }

    table button,
    .protocol-table .btn {
        padding: 0;
        margin: 0;
        font-size: 0.7rem;
        line-height: 1;
        min-width: 0;
    }

    .status-btn,
    .status-btn-compact,
    .btn-delete-row,
    .btn-open {
        box-sizing: border-box;
        width: 1.75rem;
        height: 1.75rem;
        min-width: 1.75rem;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 1.75rem;
    }

    .paginator {
        margin-top: 0.65rem;
        margin-bottom: 0;
    }

    .pagination {
        max-width: 100%;
        justify-content: center;
    }

    ul li button.page-link-number {
        width: 2.15rem;
        height: 2.15rem;
        padding: 0.25rem;
        font-size: 0.8rem;
    }

    ul li button.page-link-nav {
        min-width: 3.25rem;
        height: 2.15rem;
        padding: 0.25rem 0.55rem;
        font-size: 0.72rem;
    }
}
</style>
